import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  TextField,
  CircularProgress,
} from '@mui/material';
import UI from '../../../constants/ui';
import ERROR_MESSAGE from '../../../constants/errorMsgs';

function OTPDialog({
  open,
  onClose,
  register,
  handleSubmit,
  errors,
  handleVerifyOtp,
  countdown,
  handleResendClick,
  verifyOtp,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography align="center" variant="h6">
          {UI.ENTER_OTP_FROM_EMAIL}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <div
          style={{
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
               justifyContent: 'center',
              marginBottom: '1rem',
              width: '100%',
            }}
          >
            <label htmlFor="otp" style={{ marginRight: '0.5rem' }}>
              {UI.OTP}:
            </label>
            <TextField
              id="otp"
              type="number"
              placeholder={UI.OTP}
              variant="outlined"
              size="small"
              error={!!errors.otp}
              {...register('otp', {
                required: ERROR_MESSAGE.REQ_ERROR_MSG,
                validate: {
                  validValue: (value) => {
                    const numericValue = parseInt(value, 10);
                    if (Number.isNaN(numericValue)) {
                      return ERROR_MESSAGE.NUMBER_VALIDATION_MESSAGE;
                    }
                    if (numericValue < 100000 || numericValue > 999999) {
                      return ERROR_MESSAGE.OTP_ERROR_MESSAGE;
                    }
                    return true;
                  },
                },
              })}
            />
          </div>
          <span
            onClick={countdown === 0 ? handleResendClick : undefined}
            style={{
              cursor: countdown === 0 ? 'pointer' : 'default',
              color: countdown === 0 ? 'blue' : 'grey',
              fontSize: '12px',
              marginBottom: '1rem',
            }}
          >
            {countdown === 0
              ? UI.RESEND_OTP
              : `${UI.RESEND_OTP_IN} ${countdown} ${UI.SECONDS}`}
          </span>
          <Button
            variant="contained"
            size="large"
            onClick={handleSubmit(handleVerifyOtp)}
            startIcon={
              verifyOtp && <CircularProgress size="1rem" color="inherit" />
            }
          >
            {UI.VERIFY}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

OTPDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleVerifyOtp: PropTypes.func.isRequired,
  countdown: PropTypes.number,
  handleResendClick: PropTypes.func.isRequired,
  verifyOtp: PropTypes.bool,
};

OTPDialog.defaultProps = {
  errors: {},
  countdown: 0,
  verifyOtp: false,
};

export default OTPDialog;
